module.exports = __webpack_public_path__ + "img/detail_img5.99993797.jpg";